import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography, { COLORS } from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(0.5),
    flexShrink: 0,
    transformOrigin: '0 0',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.standard,
    }),
    position: 'absolute',
    left: 0,
  },
});

const Label = React.forwardRef((props, ref) => {
  const {
    className,
    classes,
    label,
    color,
    transform,
  } = props;

  const rootStyle = {
    transform,
  };

  return (
    <Typography
      ref={ref}
      color={color}
      component="div"
      variant="h5"
      className={classNames(classes.root, className)}
      style={rootStyle}
    >
      {label}
    </Typography>
  );
});

Label.defaultProps = {
  className: '',
};

Label.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(COLORS).isRequired,
  transform: PropTypes.string.isRequired,
};

export default withStyles(styles)(Label);
